module.exports = __webpack_public_path__ + "img/logo1.a6b44caa.png";